import {getWebServiceUrl} from "../../../util/misc";
import {nsRequest} from "../../../req/fn";
import {TServiceName} from "../../../constants/ApiServices";

export namespace nsFile {

    export function downloadFile(options: {
        servicename: TServiceName
        filename: string
        params: any
    }): Promise<void> {
        const url = `${getWebServiceUrl(options.servicename)}?rnd=${new Date().getTime()}`
        const getPostParams: any = () => {
            const ret = new URLSearchParams()
            const params = nsRequest.getParams(options.servicename, options.params)
            Object.keys(params).forEach(key => ret.set(key, (params as any)[key]))
            return ret
        }
        const fetchParams: RequestInit = {
            method: "POST",
            body: getPostParams(),
        }
        return window.fetch(url, fetchParams)
            .then(response => {
                if (!response.ok) {
                    throw response.statusText
                }
                return response.blob()
            })
            .then(blob => {
                return blob.text()
                    .then(text => {
                        let lastError = null
                        try {
                            const obj = JSON.parse(text)
                            if (!!obj.lasterror) {
                                lastError = obj.lasterror
                            }
                        } catch(e) {
                        }
                        if (lastError) {
                            throw lastError
                        }
                    })
                    .then(() => {
                        const el = document.createElement('a')
                        el.download = options.filename
                        el.href = URL.createObjectURL(blob);
                        el.click()
                    })
            })
    }

}